import { Action } from '@ngrx/store';
import { TableState } from '../../../shared/components/asset-data-table/asset-data-table.helpers';
import { SortObject, TableFilterObject } from '../types';

export const SORT_REQUEST_ASSETS_LIST = '[Request View] Sort Request Asset List';
export const FILTER_REQUEST_ASSETS_LIST = '[Request View] Filter Request Asset List';
export const LIST_TABLE_STATE = '[Request View] List Table State';
export const LIST_TABLE_STATE_COMPLETE = '[Request View] List Table State Complete';

export class SortRequestAssetsAction implements Action {
    readonly type = SORT_REQUEST_ASSETS_LIST;

    constructor(public payload: { requestId: number, sort: SortObject }) { }
}

export class FilterRequestListAction implements Action {
    readonly type = FILTER_REQUEST_ASSETS_LIST;

    constructor(public payload: { requestId: number, filter: TableFilterObject, reset?: boolean }) { }
}

export class ListTableStateAction implements Action {
    readonly type = LIST_TABLE_STATE;

    constructor(public payload: { requestId: number, stateKey: string }) { }
}

export class ListTableStateCompleteAction implements Action {
    readonly type = LIST_TABLE_STATE_COMPLETE;

    constructor(public payload: { requestId: number, tableState: TableState }) { }
}

export type Actions
    = SortRequestAssetsAction
    | FilterRequestListAction
    | ListTableStateAction
    | ListTableStateCompleteAction;
